import { PaymentStatusCheck } from './container/paymentStatusCheck';
import { HeaderFooterHOC } from 'components/HeaderFooterHOC';

export default HeaderFooterHOC(PaymentStatusCheck);
